import React from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import '../styles/custom.scss'
import { App } from './app'
import './fonts/fonts.css'
const domNode = document.getElementById('app')
const CLIENT_ID = '857837490780-thq3mdoogbvuup80j4rehlknpj8vc25j.apps.googleusercontent.com'

import { GoogleOAuthProvider } from '@react-oauth/google'
import { NotifcationProvider } from './main/components/notifications'
import { Provider } from './components/ui/provider'
if (domNode) {
    const root = createRoot(domNode)
    root.render(
        <BrowserRouter>
            <Provider>
                <NotifcationProvider>
                    <GoogleOAuthProvider clientId={CLIENT_ID}>
                        <App />
                    </GoogleOAuthProvider>
                </NotifcationProvider>
            </Provider>
        </BrowserRouter>
    )
}
